let protooPort = 4443;
if (window.location.hostname === "test.mediasoup.org")
    protooPort = 4444;
export function getProtooUrl({ hostname, roomId, peerId, consumerReplicas }) {
    return `${hostname}?roomId=${roomId}&peerId=${peerId}&consumerReplicas=${consumerReplicas}`;
}
